import { useId } from 'react';
import type React from 'react';

export interface DraftsTopbarIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const DraftsTopbarIcon: React.FC<DraftsTopbarIconProps> = ({
	width = 28,
	height = 28,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Drafts Icon',
}) => {
	const maskId = useId();

	return (
		<svg
			width={width}
			height={height}
			viewBox="7 7 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
			style={{ color }}
		>
			<mask
				id={maskId}
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="7"
				y="7"
				width="22"
				height="22"
			>
				<path d="M7 7H29V29H7V7Z" fill="white" />
			</mask>
			<g mask={`url(#${maskId})`}>
				<path
					d="M26.8869 12.5855C27.5134 13.429 27.8576 14.4568 27.8576 15.5198V16.2443C27.8576 14.7184 26.6201 13.4809 25.0943 13.4809H23.412C22.4663 13.4809 21.6989 12.7135 21.6989 11.7673V10.0856C21.6989 8.55973 20.4614 7.32223 18.9355 7.32223H19.66C20.9654 7.32223 22.2175 7.84086 23.14 8.7634L25.9064 11.5297"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27.8564 15.5194V26.9641C27.8564 27.9107 27.0894 28.6777 26.1432 28.6777H12.0667C11.258 28.6777 10.5804 28.1174 10.4004 27.3637L10.3535 20.5498V16.7702"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.3535 9.17896V9.03587C10.3535 8.08927 11.1205 7.32228 12.0667 7.32228H19.6593"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.2762 10.7902L10.5525 9.41396C10.3696 9.06613 9.93861 8.93219 9.59078 9.11511L8.52339 9.67641C8.17504 9.85959 8.04163 10.2903 8.22454 10.6381L8.94822 12.0143"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.0801 10.4165C11.6908 9.98629 12.7431 9.55497 13.8086 10.5497C15.457 12.0891 17.0624 18.3335 18.2213 18.941"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.2051 22.0426L17.1264 19.9805"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinejoin="round"
				/>
				<path
					d="M18.0508 26.4976L18.269 26.9751"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.4335 20.802C14.6657 24.5665 17.0385 27.0294 18.05 26.4975C19.2084 25.8882 18.1419 21.5801 15.6678 16.8751C14.4131 14.4899 13.0377 12.46 11.8354 11.1181C11.5088 10.7537 10.9756 10.6592 10.542 10.8869L9.44376 11.4649C9.0102 11.6926 8.78591 12.1855 8.90106 12.6615C9.32516 14.4121 10.2181 16.6959 11.4723 19.0815C11.557 19.2426 11.642 19.4016 11.7275 19.5593"
					stroke="currentColor"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};

export default DraftsTopbarIcon;
